import { Line } from 'vue-chartjs'

export default {
  props: ['updates'],
  extends: Line,
  mounted () {
    this.renderChart(
      {
        datasets: [
          {
            label: 'Stock evolution',
            borderColor: 'grey',
            backgroundColor: 'grey',
            fill: true,
            data: this.updates.map(update => ({ t: new Date(update.createdAt), y: update.stock })),
            steppedLine: 'after'
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            type: 'time',
            position: 'bottom',
            time: {
              minUnit: 'day'
            }
          }]
        }
      }
    )
  }
}
